import styled from 'styled-components'

const StyledSocialProfileSheet = styled.div`
  padding-bottom: var(--bottom-spacing);
`

export default StyledSocialProfileSheet
